export class CookieHelper {

    public setCookie(name: string, value: string, days: number) {
        // Calculate and create the expiration string
        const date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        const expirationString = `; expires=${  date.toUTCString()}`;

        // Create or update the cookie
        document.cookie = `${name}=${value || ""}${expirationString}; path=/`;
    }

    public doesCookieExist(name: string) {
        // If null is returned, the cookie does not exist
        return this.getCookieValue(name) !== null;
    }

    public getCookieValue(name: string) {
        // Create the name to check for in the cookie list
        const nameToCheckfor = `${name}=`;
        // Split all the cookies into an array
        const allCookies = document.cookie.split(";");
        for(let i = 0; i < allCookies.length; i++) {
            // Get the current cookie
            let currentCookie = allCookies[i];

            // Skip the whitespaces at the start of the cookie before checking if the
            // current cookie has the right name
            while (currentCookie.charAt(0) === " ") {
                currentCookie = currentCookie.substring(1, currentCookie.length);
            }
            // Return the value of the cookie if the name is found
            if (currentCookie.indexOf(nameToCheckfor) === 0) {
                return currentCookie.substring(nameToCheckfor.length, currentCookie.length);
            }
        }

        // Return null if the cookie was not found
        return null;
    }

    public deleteCookie(name: string) {
        document.cookie = `${name}=; Max-Age=-99999999;`; 
    }
}

export const CookieHelperSingleton = new CookieHelper();
